import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import UnknownIcon from "@mui/icons-material/HelpTwoTone"; /*  */
import EraserIconImg from "../../../../images/misc-icons/eraserIcon.svg";
import Icon from "@mui/material/Icon";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useSharedActions, useSharedDispatch, useSharedSelector } from "../../../../store/SharedProvider";
import {
  selectZonePlannerModeState,
  selectZonePlannerMouseState,
} from "../../../../store/room/zone-planner/zone-planner-selectors";
import { selectZonePlannerMapDrawColor } from "../../../../store/room/maps/maps-selectors";
import ZoneControllerMouseState from "../../../../enums/robot/zone-planner/zone-controller-mouse-state";
import MapColors from "../../../../enums/robot/rooms/map-colors";
import ZonePlannerModeState from "../../../../enums/robot/zone-planner/zone-planner-mode-state";
import SideBarIconButton from "../SideBarIconButton";

const EditMapTools: React.FC = () => {
  const { t } = useTranslation();

  const dispatch = useSharedDispatch();

  const zonePlannerModeState = useSharedSelector((state) => selectZonePlannerModeState(state));
  const zonePlannerMouseState = useSharedSelector((state) => selectZonePlannerMouseState(state));
  const zonePlannerMapDrawColor = useSharedSelector((state) => selectZonePlannerMapDrawColor(state));

  const { setMapDrawColor, setZonePlannerMouseState } = useSharedActions();

  useEffect(() => {
    if (zonePlannerMouseState === ZoneControllerMouseState.Default && zonePlannerMapDrawColor != null) {
      dispatch(setMapDrawColor(null));
    }
  }, [dispatch, zonePlannerMapDrawColor, zonePlannerMouseState]);

  const setColorClickHandler = (color: MapColors) => {
    if (zonePlannerMapDrawColor !== color) {
      dispatch(setMapDrawColor(color));
      dispatch(
        setZonePlannerMouseState(
          color === MapColors.Forbidden
            ? ZoneControllerMouseState.DrawLineTool
            : ZoneControllerMouseState.DrawRectangleTool,
        ),
      );
    } else {
      dispatch(setMapDrawColor(null));
      dispatch(setZonePlannerMouseState(ZoneControllerMouseState.Default));
    }
  };

  if (zonePlannerModeState !== ZonePlannerModeState.EditMap) {
    return null;
  }

  return (
    <React.Fragment>
      <SideBarIconButton
        isSelected={zonePlannerMapDrawColor === MapColors.Allowed}
        tooltipText={t("zoneplannercontrols-draw-color-allowed")}
        onClick={() => setColorClickHandler(MapColors.Allowed)}
      >
        <Icon>
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <img src={EraserIconImg} height={24} />
        </Icon>
      </SideBarIconButton>
      <SideBarIconButton
        isSelected={zonePlannerMapDrawColor === MapColors.Forbidden}
        tooltipText={t("zoneplannercontrols-draw-color-forbidden")}
        onClick={() => setColorClickHandler(MapColors.Forbidden)}
      >
        <ModeEditIcon
          sx={{
            color: `rgb(${MapColors.Forbidden} ${MapColors.Forbidden} ${MapColors.Forbidden})`,
          }}
        />
      </SideBarIconButton>
      <SideBarIconButton
        isSelected={zonePlannerMapDrawColor === MapColors.Unknown}
        tooltipText={t("zoneplannercontrols-draw-color-unknown")}
        onClick={() => setColorClickHandler(MapColors.Unknown)}
      >
        <UnknownIcon sx={{ color: "black" }} />
      </SideBarIconButton>
    </React.Fragment>
  );
};

export default EditMapTools;
